"use strict";
/**
 * Provide a series of type guard predicates that satisfies the input,
 * and a function that will resolve the value if it matches the type guard.
 *
 * In other words this is a type safe `if else` statement.
 *
 * In case the provided type guards list doesn't cover the entire input type,
 * you'll get a type error at compile time.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.match = void 0;
// endregion
function match() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // @ts-expect-error
    return function (t) {
        for (var i = 0; i < args.length; i++) {
            if (args[i][0](t)) {
                return args[i][1](t);
            }
        }
    };
}
exports.match = match;
